var exports = {
  "Qs": "RecipientList.module__content___V3NfQ2",
  "Rt": "RecipientList.module__searchInput___V3NfQ2",
  "qc": "RecipientList.module__searchIcon___V3NfQ2",
  "qI": "RecipientList.module__listContainer___V3NfQ2",
  "XG": "RecipientList.module__scroller___V3NfQ2",
  "wV": "RecipientList.module__noResults___V3NfQ2",
  "PR": "RecipientList.module__friendList___V3NfQ2",
  "eH": "RecipientList.module__friendItem___V3NfQ2",
  "j8": "RecipientList.module__friendItemLeft___V3NfQ2",
  "Hb": "RecipientList.module__friendInfo___V3NfQ2",
  "G3": "RecipientList.module__friendName___V3NfQ2",
  "hw": "RecipientList.module__friendSecondary___V3NfQ2",
  "hP": "RecipientList.module__actionButton___V3NfQ2",
};

module.exports = exports;
